import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SharedProgrammesList from './shared_programmes_list';
import SharedProgrammeStartPage from './shared_programme_start_page';
import TopNavBar from '../user/top_nav_bar';
import { programmesComparer } from '../../services/programmes';
import {
  useCurrentProgrammeEnrollmentQuery,
  useGetEndUserSpaceQuery,
  useGetSharedProgrammesForEndUserQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const SharedProgrammesView = () => {
  const navigate = useNavigate();

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const { data: currentProgrammeEnrollment } =
    useCurrentProgrammeEnrollmentQuery();

  const { data: sharedProgrammes, isLoading: isSharedProgrammesLoading } =
    useGetSharedProgrammesForEndUserQuery();

  const sortedSharedProgrammes = useMemo(() => {
    const intermediateProgrammes = [...(sharedProgrammes || [])];
    intermediateProgrammes.sort(programmesComparer);
    return intermediateProgrammes;
  }, [sharedProgrammes]);

  const { sharedProgrammeId } = useParams();

  const categoryConfigurations =
    currentSpace?.sharedProgrammeConfiguration?.sharedProgrammeCategories || [];

  if (sharedProgrammeId) {
    return <SharedProgrammeStartPage sharedProgrammeId={sharedProgrammeId} />;
  }

  return (
    <>
      <TopNavBar />
      <div className="shared-programmes-view">
        <div className="alternatives-page">
          <div className="topNavBarMobile">
            <div className="screen-title" style={{ flexGrow: 1 }}>
              Programs
            </div>
          </div>
          <div style={{ paddingLeft: '23px' }}>
            <SharedProgrammesList
              sharedProgrammes={sortedSharedProgrammes}
              categoryConfigurations={categoryConfigurations}
              onClickSharedProgramme={(spid) =>
                navigate(`/shared_programmes/${spid}`)
              }
              currentProgrammeEnrollment={currentProgrammeEnrollment}
            />
          </div>
        </div>
        {(!sortedSharedProgrammes || sortedSharedProgrammes.length === 0) &&
          !isSharedProgrammesLoading && (
            <div
              style={{
                height: 'var(--app-height)',
                width: '100%',
                display: 'flex',
              }}>
              <div style={{ margin: 'auto' }}>Nothing here yet</div>
            </div>
          )}
      </div>
    </>
  );
};

export default SharedProgrammesView;
